module.exports = __webpack_public_path__ + "65043542276e1f19f5928d21e70a6f3a.svg";